"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../../../helpers/StyledFunctions");
const Card_1 = tslib_1.__importDefault(require("../../Card"));
const Flex_1 = tslib_1.__importDefault(require("../../Elements/Flex"));
const Texts_1 = require("../../Texts");
const Button_1 = tslib_1.__importDefault(require("../Button"));
const defaultProps = {
    title: 'DANGER ACTION!!!',
    message: 'This action CANNOT undo! Are you sure?',
    confirmButton: 'Confirm',
    cancelButton: 'Cancel',
};
const Container = (0, styled_components_1.default)(Card_1.default) `
  width: 500px;
  background: white;
`;
const Alert = ({ title, message, confirmButton, cancelButton, onConfirm, onCancel, ...restProps }) => (react_1.default.createElement(Container, { padding: "1.5rem", flexDirection: "column" },
    react_1.default.createElement(Texts_1.NormalText, { size: "1.3rem" }, title),
    react_1.default.createElement(Texts_1.NormalText, { marginBottom: "2rem" }, message),
    react_1.default.createElement(Flex_1.default, { justifyContent: "flex-end", marginTop: "1rem" },
        react_1.default.createElement(Button_1.default, { ...(0, StyledFunctions_1.extractElementType)(restProps).elementTypes, onClick: onConfirm, marginRight: "1rem" }, confirmButton),
        react_1.default.createElement(Button_1.default, { secondary: true, outline: true, onClick: onCancel }, cancelButton))));
Alert.defaultProps = defaultProps;
exports.default = Alert;
